export default __webpack_public_path__ + "static/media/TheWesternTrustCommunityRespiratoryTeamv9220429-COPDNIASPathwayV9_flowchart.ba21632e.jpg";